import { lazy, Suspense } from 'react';
import {
  Route,
  HashRouter,
  BrowserRouter,
  Routes
} from 'react-router-dom';
// import HomePage from '../pages/Homepage';

const PageOne = lazy(() => import("../pages/pageOne"));
const PageTwo = lazy(() => import("../pages/pageTwo"));
const PageThree = lazy(() => import("../pages/pageThree"));
const CssCodes = lazy(() => import("../pages/other/cssCodes"));

const Router = window.location.protocol === "file:" ? HashRouter : BrowserRouter;

let DefaultModal = PageOne;
switch (window.location.hostname){
  case "www.byteflowmedia.com":
  case "byteflowmedia.com":
    DefaultModal = PageOne;
    break;
  case "www.starbrim.xyz":
  case "starbrim.xyz":
    DefaultModal = PageTwo;
    break;
  // case "localhost":
  //   DefaultModal = PageOne;
  //   break;
  default:
    DefaultModal = PageThree;
    break;
}

export default function MainRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/css-codes" element={
          <Suspense fallback={<div>...</div>}>
            <CssCodes />
          </Suspense> 
        } />
        <Route path="/*" element={
          <Suspense fallback={<div>...</div>}>
            <DefaultModal />
          </Suspense>
        } />
        {/* <Route path="/*" element={
          <HomePage />
        } /> */}
      </Routes>
    </Router>
  );
}
